import { Row, Col } from 'antd';
import { InputField, SelectField } from '@/components/Form';
import { MONTHS, YEARS } from '@/constant/options';
import { currencies } from '@/utils/currenciesUtils';
import FormMainLabel from '@/components/Elements/Heading/FormMainLabel';

interface CompanyFieldProps {
  control: any;
  errors: any;
  watchSalaryCurrency: string | undefined;
  watchAllowanceIncome: boolean | undefined;
  watchCommissionIncome: boolean | undefined;
  watchAnnualCashBonus: boolean | undefined;
  watchStockUnit: boolean | undefined;
}

export const CompanyField: React.FC<CompanyFieldProps> = ({
  control,
  errors,
  watchSalaryCurrency,
  watchAllowanceIncome,
  watchCommissionIncome,
  watchAnnualCashBonus,
  watchStockUnit,
}) => {
  return (
    <Col xl={24}>
      <Row gutter={30}>
        <Col xs={24}>
          <FormMainLabel index={2} label="When did you start your company?" />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch={true}
            options={MONTHS}
            name="operationStartMonth"
            control={control}
            size="large"
            label="Started Month"
            placeholder="Select company start month"
            error={errors?.operationStartMonth?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch={true}
            options={YEARS}
            name="operationStartYear"
            control={control}
            size="large"
            label="Started Year"
            placeholder="Select company start year"
            error={errors?.operationStartYear?.message ?? ''}
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel index={3} label="What is your industry?" />
        </Col>
        <Col xs={24}>
          <InputField
            label="Enter your industry?"
            name="industry"
            control={control}
            error={errors?.industry?.message ?? ''}
            placeholder="Enter your industry"
            size="large"
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel index={4} label="What is your income?" />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch={true}
            options={currencies}
            name="companySalaryCurrency"
            control={control}
            size="large"
            label="Salary Currency"
            placeholder="Select your salary currency"
            error={errors?.companySalaryCurrency?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="This year net income after taxes"
            name="thisYearPersonalNetIncomeAfterTaxes"
            control={control}
            error={errors?.thisYearPersonalNetIncomeAfterTaxes?.message ?? ''}
            placeholder="Enter your this year net income after taxes"
            size="large"
            type="number"
            prefix={watchSalaryCurrency}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Last year net income after taxes"
            name="lastYearPersonalNetIncomeAfterTaxes"
            control={control}
            error={errors?.lastYearPersonalNetIncomeAfterTaxes?.message ?? ''}
            placeholder="Enter your last year net income after taxes"
            size="large"
            type="number"
            prefix={watchSalaryCurrency}
          />
        </Col>

        <Col xs={24}>
          <FormMainLabel
            index={5}
            label="What is your ownership in the company?"
          />
        </Col>
        <Col xs={24}>
          <InputField
            label="Please advise your ownership percentage of the company?"
            name="ownershipPercentage"
            control={control}
            error={errors?.ownershipPercentage?.message ?? ''}
            placeholder="Enter your ownership percentage"
            size="large"
            type="number"
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel index={6} label="What is your company's net income?" />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="This year Company net income after taxes"
            name="thisYearCompanyNetIncomeAfterTaxes"
            control={control}
            error={errors?.thisYearCompanyNetIncomeAfterTaxes?.message ?? ''}
            placeholder="Enter your this year company net income after taxes"
            size="large"
            type="number"
            prefix={watchSalaryCurrency}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Last year Company net income after taxes"
            name="lastYearCompanyNetIncomeAfterTaxes"
            control={control}
            error={errors?.thisYearCompanyNetIncomeAfterTaxes?.message ?? ''}
            placeholder="Enter your last year company net income after taxes"
            size="large"
            type="number"
            prefix={watchSalaryCurrency}
          />
        </Col>
      </Row>
    </Col>
  );
};
